import { Component, For } from "solid-js";
import { NewImage } from "../types";

type Props = {
    resources: NewImage[];
}

export const EmbeddedResourcesTab : Component<Props> = ({ resources }) =>{
    return (
        <For each={resources}>{(item) =>
            <div class="row">
                <div class="col-md-12" style="background-color: #000; padding: 40px; text-align: center;">
                    <div class="iframe-wrapper" style="min-height: 800px; width: 100%;">
                        <div innerHTML={item.embeddedUrl} />
                    </div>
                </div>
            </div>
        }</For>
    );
}